function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(246, 246, 246)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'aleutian-blue': 'rgb(31, 93, 135)','forest-green': 'rgb(0, 109, 74)','big-sky-blue': 'rgb(82, 181, 209)','leaf-green': 'rgb(140, 151, 38)','blue': 'rgb(33, 59, 123)',};

    this.images = {'olive-slate': 'url("//crazycreek.eu/cdn/shop/files/134_68x.png?v=13092127685520670310")','copper-slate': 'url("//crazycreek.eu/cdn/shop/files/179_68x.png?v=8096876239222280458")','aleutian-blue-slate': 'url("//crazycreek.eu/cdn/shop/files/185_68x.png?v=8272491065861321484")','kings-camo-xk7': 'url("//crazycreek.eu/cdn/shop/files/190_68x.png?v=17739241391453534950")','original': 'url("//crazycreek.eu/cdn/shop/files/1024.190_back_68x.png?v=489988303048979473")','longback': 'url("//crazycreek.eu/cdn/shop/files/1039-134_HEX_LB_Olive_back_angle_d66a0adf-df73-46e8-b415-21dddf472c8a_68x.jpg?265")','powerlounger': 'url("//crazycreek.eu/cdn/shop/files/714656553185_185_P_1_317f7139-b612-44cf-a7e5-2f034faceb19_68x.png?265")','red-slate': 'url("//crazycreek.eu/cdn/shop/files/1020-158_swatch_68x.jpg?v=1002270093957302530")','coyote-tan': 'url("//crazycreek.eu/cdn/shop/files/1020-138_swatch_68x.jpg?v=5267877592394144533")','purple-teal': 'url("//crazycreek.eu/cdn/shop/files/1020-100_swatch_68x.jpg?v=18296803844091575935")','navy': 'url("//crazycreek.eu/cdn/shop/files/navy_swatch_68x.jpg?v=9896271328453304675")','blue-tie-dye': 'url("//crazycreek.eu/cdn/shop/files/1020-157_swatch_68x.jpg?v=3438004700598382665")','forest': 'url("//crazycreek.eu/cdn/shop/files/1020-050_swatch_68x.jpg?v=15857829836489013344")','green': 'url("//crazycreek.eu/cdn/shop/files/1020-049_swatch_68x.jpg?v=4072326033878553807")','army-green': 'url("//crazycreek.eu/cdn/shop/files/1020-137_swatch_68x.jpg?v=15321594760591933236")','black': 'url("//crazycreek.eu/cdn/shop/files/black_swatch_68x.jpg?v=4677605475144334385")','slate': 'url("//crazycreek.eu/cdn/shop/files/1020-042_swatch_68x.jpg?v=7068690656830188125")','tie-dye': 'url("//crazycreek.eu/cdn/shop/files/1020-243_swatch_68x.jpg?v=18039668585566403491")','mint': 'url("//crazycreek.eu/cdn/shop/files/1020-160_swatch_68x.jpg?v=4411699347854415555")','maroon': 'url("//crazycreek.eu/cdn/shop/files/1020-159_swatch_68x.jpg?v=5751811175150575878")','kings-camo-soft-fabric': 'url("//crazycreek.eu/cdn/shop/files/1020-190_swatch_68x.jpg?v=15913024311381528933")','kings-camo': 'url("//crazycreek.eu/cdn/shop/files/1020-190_swatch_68x.jpg?v=15913024311381528933")','army-green-soft-fabric': 'url("//crazycreek.eu/cdn/shop/files/1020-137_swatch_68x.jpg?v=15321594760591933236")','coyote-tan-soft-fabric': 'url("//crazycreek.eu/cdn/shop/files/1020-138_swatch_68x.jpg?v=5267877592394144533")','og': 'url("//crazycreek.eu/cdn/shop/files/1020-016_back_68x.jpg?265")','longback': 'url("//crazycreek.eu/cdn/shop/files/714656207729_016_S_1_68x.png?265")','smoky-blue-black': 'url("//crazycreek.eu/cdn/shop/files/SmokeyBlue_Black_68x.jpg?v=8816882233601860508")','slate-black': 'url("//crazycreek.eu/cdn/shop/files/Slate_Black_68x.jpg?v=14090646943907523975")','sage-black': 'url("//crazycreek.eu/cdn/shop/files/Sage_Black_68x.jpg?v=8869643238503226497")','black-blue': 'url("//crazycreek.eu/cdn/shop/files/SmokeyBlue_Black_68x.jpg?v=8816882233601860508")','grey-yellow': 'url("//crazycreek.eu/cdn/shop/files/Black_Yellow_68x.jpg?v=14296914586214519553")','sunflower-pattern': 'url("//crazycreek.eu/cdn/shop/files/Wildflower_pattern_68x.jpg?265")',};

    this.triggers = ['color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
